import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from '../shared/components/Header';
import Footer from '../shared/components/Footer';
import PWAInstallPrompt from '../shared/components/PWAInstallPrompt';
import ScrollToTopButton from '../shared/components/ScrollToTopButton';
import { LoadingPage } from '../shared/components/LoadingSpinner';
import { withAuth, withAdmin } from '../features/auth/AuthContext';

const Home = lazy(() => import('../features/marketing/Home'));
const Properties = lazy(() => import('../features/properties/Properties'));
const PropertyDetail = lazy(() => import('../features/properties/PropertyDetail'));
const Blog = lazy(() => import('../features/marketing/Blog'));
const About = lazy(() => import('../features/marketing/About'));
const Contact = lazy(() => import('../features/marketing/Contact'));
const AdminPanel = lazy(() => import('../features/admin/AdminPanel'));
const ListProperty = lazy(() => import('../features/properties/ListProperty'));
const Favorites = lazy(() => import('../features/properties/Favorites'));
const FeaturedProperties = lazy(() => import('../features/properties/FeaturedProperties'));
const PricingEnquiry = lazy(() => import('../features/properties/PricingEnquiry'));
const Login = lazy(() => import('../features/auth/Login'));
const Register = lazy(() => import('../features/auth/Register'));
const ResetPassword = lazy(() => import('../features/auth/ResetPassword'));
const VerifyEmail = lazy(() => import('../features/auth/VerifyEmail'));
const ProfileSettings = lazy(() => import('../features/auth/ProfileSettings'));
const TermsAndConditions = lazy(() => import('../features/marketing/TermsAndConditions'));
const BuyersChecklist = lazy(() => import('../features/marketing/BuyersChecklist'));
const ProfessionalServices = lazy(() => import('../features/marketing/ProfessionalServices'));
const SalesAndMarketingServices = lazy(() => import('../features/marketing/SalesAndMarketingServices'));
const BuildingPermitDocuments = lazy(() => import('../features/marketing/BuildingPermitDocuments'));
const NRIDocuments = lazy(() => import('../features/marketing/NRIDocuments'));
const EMICalculator = lazy(() => import('../features/marketing/EMICalculator'));
const MyProperties = lazy(() => import('../features/properties/MyProperties'));
const EditSubmission = lazy(() => import('../features/properties/EditSubmission'));
const UserManagement = lazy(() => import('../features/admin/UserManagement'));
const WordPressMigration = lazy(() => import('../features/admin/WordPressMigration'));
const BlogManagement = lazy(() => import('../features/admin/BlogManagement'));
const BannerSettings = lazy(() => import('../features/admin/BannerSettings'));

const ProtectedListProperty = withAuth(ListProperty);
const ProtectedAdminPanel = withAdmin(AdminPanel);
const ProtectedUserManagement = withAdmin(UserManagement);
const ProtectedWordPressMigration = withAdmin(WordPressMigration);
const ProtectedBlogManagement = withAdmin(BlogManagement);
const ProtectedBannerSettings = withAdmin(BannerSettings);

export function AppRoutes() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-900">
      <Header />
      <main className="flex-1">
        <Suspense fallback={<LoadingPage message="Loading..." />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/featured" element={<FeaturedProperties />} />
            <Route path="/enquiry/:id" element={<PricingEnquiry />} />
            <Route path="/properties/:id" element={<PropertyDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/buyers-checklist" element={<BuyersChecklist />} />
            <Route path="/professional-services" element={<ProfessionalServices />} />
            <Route path="/sales-and-marketing-services" element={<SalesAndMarketingServices />} />
            <Route path="/documents-required-for-building-permit" element={<BuildingPermitDocuments />} />
            <Route path="/essential-documents-for-nri-sellers-in-kerala" element={<NRIDocuments />} />
            <Route path="/emi-calculator" element={<EMICalculator />} />
            <Route path="/profile" element={<ProfileSettings />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/admin" element={<ProtectedAdminPanel />} />
            <Route path="/list-property" element={<ProtectedListProperty />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/my-properties" element={<MyProperties />} />
            <Route path="/edit-submission/:id" element={<EditSubmission />} />
            <Route path="/admin/users" element={<ProtectedUserManagement />} />
            <Route path="/admin/wordpress" element={<ProtectedWordPressMigration />} />
            <Route path="/admin/blog" element={<ProtectedBlogManagement />} />
            <Route path="/admin/banners" element={<ProtectedBannerSettings />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <PWAInstallPrompt />
      <ScrollToTopButton />
    </div>
  );
}
